import React, { useContext } from 'react';
import EmployeeSearchAutocomplete from '../EmployeeSearchAutocomplete/EmployeeSearchAutocomplete';
import { IFilterValueSelectorProps } from './interfaces';
import _ from 'lodash';
import { useGetAllEmployees } from '../../../services/react-query/employees';
import { DisableContext } from '../../../contexts/DisableContextProvider';

export default function EmployeeFilterSelector({ filterValues, setFilterValues }: IFilterValueSelectorProps) {
  const filteredUuids = _.compact(filterValues);
  const { disabled } = useContext(DisableContext);
  const { data: employees } = useGetAllEmployees({
    params: {
      filters: {
        uuid: filteredUuids,
      },
      per_page: 0,
    },
    enabled: !_.isEmpty(filteredUuids),
  });

  return (
    <EmployeeSearchAutocomplete
      isMultiple
      value={_.filter(employees?.data, (employee) => _.includes(filterValues, employee.uuid))}
      onChange={(employees) => setFilterValues(_.map(employees, 'uuid'))}
      isDisabled={disabled}
    />
  );
}
